import Vue from "vue";
import VueRouter from "vue-router";
// import occupationNav from '@/views/occupation/occupationNav.vue'
// import Login from '@/views/login/login.vue'

Vue.use(VueRouter);

const routes = [
    // 首页
    {
        path: "/",
        name: "Login",
        component: () => import("../views/login/login.vue"),
    },
    // 主页
    {
        path: "/home",
        name: "home",
        component: () => import("../views/home/home.vue"),
        children: [
            // 职位管理
            // {
            // 	path: "/job",
            // 	name: "occupationNav",
            // 	component: () => import("../views/occupation/occupationNav.vue"),
            // },
            // 聊天
            {
                path: "/chatHome",
                name: "chatHome",
                component: () => import("../views/chat/chat_home.vue"),
            },
            // 面试管理
            {
                path: "/interviewAdm",
                name: "interviewMsgl",
                component: () => import("../views/interview/interview_msgl.vue"),
            },
            // 企业管理
            {
                path: "/company",
                name: "company",
                component: () => import("../views/businessmanagement/company.vue"),
            },
            // 企业详情
            {
                path: "/Businessdetails",
                name: "Businessdetails",
                component: () => import("../views/businessmanagement/component/Businessdetails.vue"),
            },
            // {
            //   path: '/personalData',
            //   name: 'personalData',
            //   component: () => import('../views/personal/personal_data.vue')
            // },
            //  我的资料
            {
                path: "/personalHome",
                name: "personalHome",
                component: () => import("../views/personal/personal_home.vue"),
            },
            //  角色管理
            {
                path: "/roleAdm",
                name: "roleGl",
                component: () => import("../views/authority/role_gl.vue"),
            },
            //  用户管理
            {
                path: "/userAdm",
                name: "userGl",
                component: () => import("../views/authority/user_gl.vue"),
            },
            // 测试路由
            {
                path: "/text",
                name: "text",
                component: () => import("../views/authority/text.vue"),
            },
            // 油田认证
            {
                path: "/fieldHome",
                name: "fieldHome",
                component: () => import("../views/audit/field/field_home.vue"),
            },
            //  企业认证
            {
                path: "/enterpriseHome",
                name: "enterpriseHome",
                component: () => import("../views/audit/enterprise/enterprise_home.vue"),
            },
            // 企业认证详情
            {
                path: "/enterdetails",
                name: "enterdetails",
                component: () => import("../views/audit/enterprise/components/enterdetails.vue"),
            },
            // 企业认证详情
            {
                path: "/entershenpi",
                name: "entershenpi",
                component: () => import("../views/audit/enterprise/components/entershenpi.vue"),
            },

            //  灵活就业认证
            {
                path: "/flexibleJobHome",
                name: "flexibleJobHome",
                component: () => import("../views/audit/flexibleJob/flexibleJob_home.vue"),
            },
            //  见习基地认证
            {
                path: "/baseHome",
                name: "baseHome",
                component: () => import("../views/audit/base/base_home.vue"),
            },
            //  高端人才库
            {
                path: "/advanced",
                name: "advanced",
                component: () => import("../views/advanced/advanced.vue"),
            },
            {
                path: "/bindHome",
                name: "bindHome",
                component: () => import("../views/audit/bind/bind_home.vue"),
            },
            // 调查问卷
            {
                path: "/survey",
                name: "survey",
                component: () => import("../views/survey/survey.vue"),
            },
            //  文章发布
            {
                path: "/articleHome",
                name: "articleHome",
                component: () => import("../views/article/article_home.vue"),
            },
            //文章详情
            {
                path: "/addArticle",
                name: "addArticle",
                component: () => import("../views/article/add_article.vue"),
            },
            //  待招管理
            {
                path: "/recruitHome",
                name: "recruitHome",
                component: () => import("../views/recruit/recruit_home.vue"),
            },
            // 敏感词管理
            {
                path: "/sensitiveWord",
                name: "sensitiveWord",
                component: () => import("../views/sensitiveWord/sensitiveWord.vue"),
            },
            // 简历管理
            {
                path: "/resume",
                name: "resume",
                component: () => import("../views/resume/resume.vue"),
            },
            // 简历详情
            {
                path: "/resumedetails",
                name: "resumedetails",
                component: () => import("../views/resume/component/resumedetails.vue"),
            },
            // 数据统计
            {
                path: "/statistics",
                name: "statistics",
                component: () => import("../views/statistics/index.vue"),
            },
            // 客服问答
            {
                path: "/answers",
                name: "answers",
                component: () => import("../views/answers/answers.vue"),
                children: []
            },
            // 人才端-客服问答管理添加问题
            {
                path: "/answersPeopleNewadded",
                name: "answersPeopleNewadded",
                component: () => import("../views/answers/component/answersPeopleNewadded.vue"),
            },

            // 企业端-客服问答管理添加问题
            {
                path: "/answersPeopleNewadded2",
                name: "answersPeopleNewadded2",
                component: () => import("../views/answers/component/answersPeopleNewadded2.vue"),
            },
            // 企业编辑
            {
                path: "/editqiye",
                name: "editqiye",
                component: () => import("../views/businessmanagement/component/editqiye.vue"),
            },
            // 人才审批
            {
                path: "/bind_particularsOne",
                name: "bind_particularsOne",
                component: () => import("../views/audit/bind/bind_particulars1.vue"),
            },
            // 高端人才审批
            {
                path: "/advancedDetails",
                name: "advancedDetails",
                component: () => import("../views/advanced/advancedDetails.vue"),
            },

        ],
    },
];

const router = new VueRouter({
    mode: 'hash',
    routes,
});

export default router;
